const convertStringToBoolean = (value) => `${value}` === 'true';

export default convertStringToBoolean;
